import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useState
} from 'react';

// Define the interface with both bannerDetails and setBannerDetails
interface BannerContextInterface {
  bannerDetails: any; // Replace `any` with your actual type
  setBannerDetails: (details: any) => void; // Adjust `any` to match the type of bannerDetails
}

// Create the context with a default value
const BannerDetailsContext = createContext<BannerContextInterface>({
  bannerDetails: null,
  setBannerDetails: () => {} // Default no-op function
});

// Hook to use the BannerDetails context
export const useBannerDetails = (): BannerContextInterface =>
  useContext(BannerDetailsContext);

// Provider component for BannerDetailsContext
const BannerDetailsProvider = ({
  children
}: ComponentProps<FC<any>> & {children: ReactElement}): JSX.Element => {
  const [bannerDetails, setBannerDetails] = useState<any>(null); // Define the state

  return (
    <BannerDetailsContext.Provider value={{bannerDetails, setBannerDetails}}>
      {children}
    </BannerDetailsContext.Provider>
  );
};

export default BannerDetailsProvider;
